import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import {
  GetHrEvaluateeAndEvaluatorInfoRepository,
  GetHrEvaluateeAndEvaluatorInfoResponse,
} from "features/hr/data/repository/hr-appraisal.repository";
import { RootState } from "features/config/store";
import { HrEvaluateeAndEvaluatorInfoModel } from "features/hr/core/domain/hr-evaluatee-and-evaluator-info";
import { GetHrEvaluateeAndEvaluatorInfoParam } from "features/hr/core/hr.params";

export enum GetHrEvaluateeAndEvaluatorInfoState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetHrEvaluateeAndEvaluatorInfoState;
  message: string;
  data: HrEvaluateeAndEvaluatorInfoModel | undefined;
}

let initialState: InitialState = {
  status: GetHrEvaluateeAndEvaluatorInfoState.initial,
  message: "",
  data: undefined,
};

export const getHrEvaluateeAndEvaluatorInfo = createAsyncThunk(
  "getHrEvaluateeAndEvaluatorInfo",
  async (param: GetHrEvaluateeAndEvaluatorInfoParam, { rejectWithValue }) => {
    try {
      const response: GetHrEvaluateeAndEvaluatorInfoResponse =
        await GetHrEvaluateeAndEvaluatorInfoRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const getHrEvaluateeAndEvaluatorInfoSlice = createSlice({
  name: "getHrEvaluateeAndEvaluatorInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHrEvaluateeAndEvaluatorInfo.pending, (state) => {
        state.status = GetHrEvaluateeAndEvaluatorInfoState.inProgress;
      })
      .addCase(getHrEvaluateeAndEvaluatorInfo.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetHrEvaluateeAndEvaluatorInfoState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getHrEvaluateeAndEvaluatorInfo.rejected, (state, action) => {
        state.status = GetHrEvaluateeAndEvaluatorInfoState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetHrEvaluateeAndEvaluatorInfo = (state: RootState) =>
  state.getHrEvaluateeAndEvaluatorInfo;

export default getHrEvaluateeAndEvaluatorInfoSlice.reducer;
